import { createAsyncThunk } from '@reduxjs/toolkit';

import { removeUndefined } from 'commonUtils/removeUndefined';

import { sendSentryClientErrorOnce } from 'shared/lib';
import { showNotification } from 'shared/lib/showNotification';

import type { TCreditFormCommonFields } from 'entities/creditForm';
import {
  formDataToCustomerAdapter,
  prepareFormDataForCustomerUpdate,
  selectRequiredFieldsForUpdate,
  formQueries,
} from 'entities/creditForm';
import { selectIsSelectedProductTypeFeatureEnabled } from 'entities/siteSettings';
import { isLoggedSelector } from 'entities/user/model/user.selectors';

import type { TSendCustomerDataThunkState } from '../model/sendCustomerData.types';
import { SendCustomerDataTexts } from '../SendCustomerData.texts';

export const sendCustomerDataThunk = createAsyncThunk<
  boolean,
  Partial<TCreditFormCommonFields>,
  { state: TSendCustomerDataThunkState }
>('sendCustomerData/sendCustomerDataThunk', async (payload, { dispatch, getState }) => {
  const isLoggedIn = isLoggedSelector(getState());

  if (!isLoggedIn) {
    return true;
  }

  const formFields = { ...selectRequiredFieldsForUpdate(getState()), ...payload };
  const shouldIncludeSelectedProductType = selectIsSelectedProductTypeFeatureEnabled(getState());
  const preparedFormData = prepareFormDataForCustomerUpdate(formFields, shouldIncludeSelectedProductType);

  // проверяем заполнение обязательных полей, так как без них сохранение будет падать с ошибкой
  if (
    (
      ['fullName', 'birthDate', 'passportNumber', 'passportIssueDate', 'passportIssuedBy', 'unitCode'] as Array<
        Partial<keyof TCreditFormCommonFields>
      >
    ).some((key) => !formFields[key])
  ) {
    return true;
  }

  try {
    await dispatch(
      formQueries.endpoints.updateCustomerData.initiate(
        removeUndefined(formDataToCustomerAdapter(preparedFormData), [null, ''], true),
      ),
    ).unwrap();

    return true;
  } catch (error) {
    sendSentryClientErrorOnce('sendCustomerDataThunk', error);
    showNotification({ title: SendCustomerDataTexts.errorTitle, subtitle: SendCustomerDataTexts.errorDescription });

    return false;
  }
});
